import React from 'react'
import Button from '@material-ui/core/Button'
import MultiSelect from '@/custom/components/atoms/MultiSelect'
import CustomInput from '@/product/components/atoms/Inputs/CustomInput'
import { OemGrid } from './OemGrid'
import { NavigateBefore, NavigateNext } from '@material-ui/icons'

const ProductLayout = (props) => {
    const [categories, setCategories] = React.useState([])
    const [models, setModels] = React.useState([])

    const categoryOptions = [
        { value: 'forklift', label: 'Forklift' },
        { value: 'excavator', label: 'Excavator' },
        { value: 'loader', label: 'Loader' },
        { value: '250D-7E', label: '250D-7E' },
        { value: '180D-7E', label: '180D-7E' },
        { value: '110 130 160D-7E', label: '110 130 160D-7E' },
    ]

    const modelOptions = [
        { value: '250D-7E', label: '250D-7E' },
        { value: '180D-7E', label: '180D-7E' },
        { value: '110 130 160D-7E', label: '110 130 160D-7E' },
    ]

    const handleCategoryChange = (event) => {
        setCategories(event.target.value)
    }

    const handleModelChange = (event) => {
        setModels(event.target.value)
    }

    const forklifts = [
        { title: 'Forklift Construction 250D-7E - DIESEL', price: 'Price On Request' },
        { title: 'Forklift Construction 180D-7E - DIESEL', price: 'Price On Request' },
        { title: 'Forklift Construction 110 130 160D-7E - DIESEL', price: 'Price On Request' },
        { title: 'Forklift Construction 70D-7E - DIESEL', price: 'Price On Request' },
        { title: 'Forklift Construction 50 60 70D-7E ACE - DIESEL', price: 'Price On Request' },
        { title: 'Forklift Construction 35 40 45 50D-9SA - DIESEL', price: 'Price On Request' },
    ]

    return (
        <div className="container border-cont">
            <div className="filter-bar row" style={{ background: props?.theme?.backgroundColors }}>
                <div className="col-md-3">
                    <MultiSelect
                        label="Category"
                        options={categoryOptions}
                        value={categories}
                        variant="filled"
                        onChange={handleCategoryChange}
                        className="form-control"
                    />
                </div>
                <div className="col-md-3">
                    <MultiSelect
                        label="Model"
                        options={modelOptions}
                        value={models}
                        onChange={handleModelChange}
                        className="form-control"
                    />
                </div>
                <div className="col-md-3">
                    <CustomInput name="Search" placeholder="Search" type="text" />
                </div>
                <div className="col-md-3 text-right">
                    <Button className="clear-button">Clear All</Button>
                </div>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="font-bold">Total Results: 1</div>
                <div className="pagination" style={{ gap: '10px' }}>
                    <Button disabled className="pagination-button">
                        <NavigateBefore />
                    </Button>
                    <Button className="pagination-button">
                        <NavigateNext />
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default ProductLayout
